import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { taskApi } from '../../api/task.api';
import { useUI } from '../../store/UIContext';
import { Btn, EmptyState, Input, PageHeader, Spinner } from '../../components/ui/index';

/** Manager picks employees from other departments who can also receive
 * tasks from them (own-department employees are always available). */
export default function TaskMembersPage() {
  const { addToast } = useUI();
  const [members, setMembers] = useState(null);
  const [selected, setSelected] = useState(new Set());
  const [search, setSearch] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    taskApi.getExtraMembers()
      .then((res) => {
        setMembers(res.data || []);
        setSelected(new Set((res.data || []).filter((m) => m.selected).map((m) => m.employee_id)));
      })
      .catch(() => { setMembers([]); addToast('خطا در بارگذاری کارمندان', 'error'); });
  }, [addToast]);

  const grouped = useMemo(() => {
    const q = search.trim();
    const out = {};
    (members || []).filter((m) => !q || m.name.includes(q) || m.department_name.includes(q)).forEach((m) => {
      (out[m.department_name || 'بدون دپارتمان'] ||= []).push(m);
    });
    return out;
  }, [members, search]);

  const toggle = (id) => setSelected((prev) => {
    const next = new Set(prev);
    if (next.has(id)) next.delete(id); else next.add(id);
    return next;
  });

  const save = async () => {
    setSaving(true);
    try {
      await taskApi.saveExtraMembers([...selected]);
      addToast('ذخیره شد', 'success');
    } catch { addToast('خطا در ذخیره', 'error'); }
    setSaving(false);
  };

  return (
    <div className="fade-in" style={{ maxWidth: 600 }}>
      <PageHeader
        title="کارمندان قابل تعریف تسک"
        subtitle="علاوه بر کارمندان دپارتمان خودتان، می‌توانید به کارمندان زیر نیز تسک بدهید"
        action={<Link to="/settings" style={{ fontSize: 13, color: '#64748b' }}>بازگشت به تنظیمات</Link>}
      />
      {members === null ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}><Spinner /></div>
      ) : !members.length ? (
        <EmptyState title="کارمند دیگری یافت نشد" />
      ) : (
        <>
          <Input placeholder="جستجوی نام یا دپارتمان" value={search} onChange={(e) => setSearch(e.target.value)} wrapStyle={{ marginBottom: 14 }} />
          {Object.entries(grouped).map(([dept, list]) => (
            <div key={dept} style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, marginBottom: 12, overflow: 'hidden' }}>
              <div style={{ background: '#f8fafc', padding: '8px 16px', fontSize: 12, fontWeight: 700, color: '#64748b' }}>{dept}</div>
              {list.map((m) => (
                <label key={m.employee_id} style={{ display: 'flex', gap: 10, padding: '10px 16px', borderTop: '1px solid #f1f5f9', cursor: 'pointer', fontSize: 13 }}>
                  <input type="checkbox" checked={selected.has(m.employee_id)} onChange={() => toggle(m.employee_id)} />
                  {m.name}
                </label>
              ))}
            </div>
          ))}
          <Btn loading={saving} onClick={save}>ذخیره</Btn>
        </>
      )}
    </div>
  );
}
